import Vue from 'vue';
import VueI18n from 'vue-i18n';
import * as locales from './locales';
import { cookies } from '../plugins/cookies';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: cookies.get('language') || 'ru',
  fallbackLocale: 'ru',
  messages: locales,
});

export default { i18n };
